<script setup lang="ts">
import { StrapiBlocks } from "vue-strapi-blocks-renderer";


const route = useRoute();

const { data, error } = await useFetch<Press>(`/api/press/${route.params.slug}`);

const title = computed(() =>  `Press - ${data?.value?.title || ""}`);

useHead({
  title: title.value,
});


const backgroundImage = computed(() => {
  return data?.value?.images[0]?.url ? `url(${composeImageUrl(data?.value?.images[0]?.url)})` : "";
});

const fileToDownload = computed(() => {
  return data?.value?.files[0]?.url ? composeImageUrl(data?.value?.files[0]?.url) : "";
});

</script>
<template>
  <div class="content">
    
    <Breadcumb :title="title" :subtitle="'What says about me.'" :items="[{ text: 'Press', href: '/press' }]" :to="{ text: data?.title!, href: '' }" />
    <!-- Block text section start  -->

    <div class="gray-bg">
      <div class="container-fluid" style="padding: 0">
        <div
          class="hero-image-wrapper"
          :style="{
            backgroundImage: backgroundImage,
          }"
        >
          <!-- <img :src="composeImageUrl(data?.[0]?.images[0]?.url!)" :alt="`${data?.[0]?.title} Image`" /> -->
        </div>
      </div>
      <div class="container about-standard-row xboot-standard-row">
        <div class="row">
          <div class="col-md-12">
            <div class="wrapper-press">
              <div class="text-left">
                <div class="section-title-2">
                  <h2 class="area-title">{{ data?.title }}</h2>
                </div>
                <StrapiBlocks :content="data?.content || []" />
              </div>
            </div>
          </div>
          <div class="col-md-6" style="margin-top: 2rem">
            <div class="about-me-img text-right" style="overflow: hidden">
              <div class="single-block-option download-file" style="cursor: pointer; gap: 1rem">
                <i class="ti-download"></i>
                <p class="" @click="downloadFile(fileToDownload)">download press</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.hero-image-wrapper {
  width: 100%;
  height: 40rem;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: 0 8%;
  background-color: var(--background-color);
  background-size: cover;
}
/* .hero-image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: var(--primary-color);
} */

.download-file {
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}
.download-file p,
.download-file i {
  transition: all 0.3s ease;
  text-decoration: underline solid transparent 2px;
}
.download-file:hover p {
  text-decoration: underline solid var(--primary-color) 4px;
  /* transform: scale(1.05); */
}
</style>
